import styled from "styled-components";
import { device } from "../device";

export interface ListProps {
  singleCol: boolean;
}

export const BlogContentList = styled.ul<ListProps>`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  column-gap: 64px;
  row-gap: 32px;
  width: 100%;
  flex-flow: row wrap;
  align-items: stretch;
  justify-content: flex-start;
  margin-left: 0;
  padding-inline-start: 0;
  padding-left: 0;

  @media ${device.tablet} {
    ${({ singleCol }) =>
      !singleCol &&
      `
            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        `}

    li::after {
      content: "";
      flex: 0 0 auto;
      height: 1px;
      display: block;
      background-color: #d0d0d0;
      margin-top: 32px;
    }

    li:last-child {
      ${({ singleCol }) =>
        singleCol &&
        `
                margin-bottom: 32px;
                
                &:after {
                    content: none;
                    height: 0px;
                }
        `}
    }
  }
`;

export const PostContainerList = styled.li`
  list-style: none;
  grid-column: span 1;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  a,
  .inner-link-wrapper {
    height: 100%;
    text-decoration: none;
    display: flex;
    overflow: hidden;
    z-index: 0;
    position: relative;
    flex-direction: row;
    border-radius: revert;
    overflow: revert;
    z-index: revert;
    position: revert;
    background-color: transparent;

    &:hover {
      .tile-media::after {
        background: rgba(0, 0, 0, 0.15);
      }

      img {
        transform: scale(1.03);
      }
    }
  }
`;

export const TileDescriptionList = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 1;
  padding: 0 0 0 24px;
  justify-content: center;
  flex-basis: 0;
`;

export const TileMediaListFull = styled.div`
  height: auto;
  padding-right: 16px;
  width: 93px;
  max-height: 93px;

  @media ${device.tablet} {
    padding-right: 24px;
    width: 171px;
    max-height: 171px;
    min-height: 96px;
  }
  flex-basis: auto;
  flex-shrink: 1;
  border-radius: 16px;
  direction: ltr;
  position: relative;
  z-index: 0;
  flex-grow: 0;
  flex-shrink: 0;
  overflow: hidden;

  &::after {
    content: "";
    display: inline-block;
    width: 100%;
    height: 100%;

    @media ${device.tablet} {
      background: rgba(0, 0, 0, 0);
    }
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-transition: background 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
    transition: background 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
  }

  img {
    border-radius: 12px;

    transition: opacity 1s cubic-bezier(0.4, 0, 0.25, 1) 0ms,
      transform 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms,
      -webkit-transform 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
    object-fit: cover;
  }
`;

export const TileMediaList = styled.div`
  width: 132px;
  height: 132px;
  min-height: auto;
  flex-basis: auto;
  flex-shrink: 1;
  border-radius: 16px;
  direction: ltr;
  position: relative;
  z-index: 0;
  flex-grow: 0;
  flex-shrink: 0;
  overflow: hidden;

  &::after {
    content: "";
    display: inline-block;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-transition: background 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
    transition: background 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
  }

  img {
    transition: opacity 1s cubic-bezier(0.4, 0, 0.25, 1) 0ms,
      transform 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms,
      -webkit-transform 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
    object-fit: cover;
  }
`;

export const TileDescriptionCategoryList = styled.div`
  margin-bottom: 4px;
  font-size: 12px;
  line-height: 1.33337;
  font-weight: 800;
  color: #6e6e73;
`;

export const TileDescriptionHeadlineList = styled.div`
  font-size: 17px;
  line-height: 23px;
  font-weight: 800;
  color: #1d1d1f;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
`;

export const TileDescriptionHeadlineListFull = styled.div`
  font-size: 17px;
  line-height: 21px;
  @media ${device.tablet} {
    font-size: 19px;
    line-height: 23px;
  }
  font-weight: 800;
  color: #1d1d1f;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
`;
